module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Article-f27c8934b37e4bb2d44a9467605170ce.svg";